export default __webpack_public_path__ + "static/media/bn-febrero2022.0d315e55.jpg";